export enum JobPhaseReadyHourEnum {
  '8am' = 8,
  '9am' = 9,
  '10am' = 10,
  '11am' = 11,
  '12pm' = 12,
  '1pm' = 13,
  '2pm' = 14,
}
